import { skills } from '../utilities/projects_request'

export default function Skills () {
  return (
    <>
      {
      skills
        ? (
          <section
            className='flex flex-row flex-wrap gap-x-3 place-content-evenly my-[30px]'
          >
            {
            skills.map((skill) => {
              return (
                <div key={skill.id} className='place-self-center py-[10px]'>
                  <img
                    src={process.env.PUBLIC_URL + `${skill.link}`} alt={skill.alt}
                    className={skill.class}
                  />
                  <p className='text-center'>{skill.name}</p>
                </div>

              )
            })
          }
          </section>
          )
        : 'null'
    }

      <hr className='h-[3px]
my-10
min-[300px]:my-8
w-[96%] bg-gray-200 border-0 dark:bg-gray-700'
      />
    </>
  )
}
